/* eslint-disable import/no-anonymous-default-export */
import CustomProductLoanActionTypes from './custom-product-loan-proposal.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	addCustomProductProposalResponse: null,
	updateCustomProductProposalResponse: null,
	fetchCustomProductDetailsResponse: null,
	fetchCustomProductDetailsArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case CustomProductLoanActionTypes.ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_SUCCESS:
			return { ...state, addCustomProductProposalResponse: action.payload };

		case CustomProductLoanActionTypes.ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_FAILURE:
			return { ...state, addCustomProductProposalResponse: action.payload };

		case CustomProductLoanActionTypes.ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, addCustomProductProposalResponse: null };

		case CustomProductLoanActionTypes.UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_SUCCESS:
			return { ...state, updateCustomProductProposalResponse: action.payload };

		case CustomProductLoanActionTypes.UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_FAILURE:
			return { ...state, updateCustomProductProposalResponse: action.payload };

		case CustomProductLoanActionTypes.UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, updateCustomProductProposalResponse: null };

		case CustomProductLoanActionTypes.FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_SUCCESS:
			return {
				...state,
				fetchCustomProductDetailsResponse: action.payload,
				fetchCustomProductDetailsArr: docodeHexResponse(
					action.payload,
					'getCustomLoanIndexInfoKey',
				),
			};

		case CustomProductLoanActionTypes.FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_FAILURE:
			return { ...state, fetchCustomProductDetailsResponse: action.payload };

		case CustomProductLoanActionTypes.FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchCustomProductDetailsResponse: null,
			};

		default:
			return state;
	}
};
